import React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { MeatballMenu, ButtonCallToAction, ButtonTertiary } from 'ui';
import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { getBackRoute } from '../route';
import { SubscriberGroupActionType, SubscriberGroupStickyHeaderProps } from '../types';
import styles from './subscriber-group-sticky-header.scss';

export const SubscriberGroupStickyHeader: React.FC<SubscriberGroupStickyHeaderProps> = ({
  actionType, shouldPrompt, subscriberGroupItem, name, fetching, translation, onSave, mergeSubscriberGroupItem
}) => {

  const updatingItem = isDefinedIncludingZero(subscriberGroupItem?.id);
  const onCancel = () => {
    navigate.to({ pathname: getBackRoute() });
  };

  return <StickyHeader
    className={styles.header}
    rightSideContent={<>
      <StickyHeaderButtonContainer>
        <ButtonTertiary
          id="subscriber-group-form-sticky-header-cancel-button"
          onClick={onCancel}>
          {translation.cancel}
        </ButtonTertiary>
        <ButtonCallToAction
          id="subscriber-group-form-sticky-header-save-button"
          onClick={onSave}
          disabled={!shouldPrompt}>
          {translation.save}
        </ButtonCallToAction>
      </StickyHeaderButtonContainer>
      {actionType === SubscriberGroupActionType.edit && subscriberGroupItem.id !== 0
        ? <MeatballMenu id="subscriber-group-form-sticky-header-meatballmenu">
          <li>
            <button
              type="button"
              className="dropdown-item"
              disabled={fetching}
              onClick={mergeSubscriberGroupItem}>
              {translation.delete}
            </button>
          </li>
        </MeatballMenu> : null}
    </>} >
    <div className={styles.headerContainer}>
      {updatingItem ? <span className={styles.headerId}>
        #{subscriberGroupItem.id}
      </span> : null}
      <h2 className={styles.headerTitle}>
        {updatingItem
          ? name || null
          : translation.new_subscriber_group}
      </h2>
      {subscriberGroupItem.selfService && <Tag className={subscriberGroupItem.disabled && 'me-1'}>{translation.self_service}</Tag>}
      {isDisabled(subscriberGroupItem.disabled) && <Tag>{translation.disabled}</Tag>}
    </div>
  </StickyHeader>;
};
